import { FullFooter } from '@/components/Footer';
import SubscribeForm from '@/components/SubscribeForm';

const About = ({ showToast, onSubscribe }) => {
  return (
    <>
      <section className="page-hero" data-testid="about-hero">
        <h1>About Nile Capital</h1>
        <p>Built by a practitioner, not a spectator. In crypto since 2013. Four cycles survived.</p>
      </section>

      <section className="mission" data-testid="mission-section">
        <p className="mission-body">Most people think getting into crypto means setting up a wallet. It doesn't anymore.</p>
        <p className="mission-body">Public companies now hold Bitcoin and altcoins directly on their balance sheets. You can invest in them through any regular brokerage account. No wallet, no exchange, no self-custody.</p>
        <p className="mission-body">Nile Capital tracks those companies. The macro forces behind their decisions. And what the data tells us about where this cycle is heading.</p>
      </section>

      <div className="stats-bar" data-testid="stats-bar">
        <div className="stats-grid">
          <div className="stat-item"><div className="stat-number">10+</div><div className="stat-label">Years in Crypto</div></div>
          <div className="stat-item"><div className="stat-number">4</div><div className="stat-label">Market Cycles</div></div>
          <div className="stat-item"><div className="stat-number">2</div><div className="stat-label">Companies Built</div></div>
          <div className="stat-item"><div className="stat-number">100+</div><div className="stat-label">DATs Tracked</div></div>
        </div>
      </div>

      <section className="approach" data-testid="approach-section">
        <div className="approach-inner">
          <h2>How We Analyse Markets</h2>
          <div className="approach-grid">
            <div className="approach-item">
              <div className="step-number">01</div>
              <h4>Global Macro &amp; Geopolitics</h4>
              <p>We track global economic shifts and geopolitical events that move crypto markets. Expert views summarised via our newsletter and social channels.</p>
            </div>
            <div className="approach-item">
              <div className="step-number">02</div>
              <h4>Crypto &amp; Treasury Trends</h4>
              <p>Analysis of crypto trends impacting treasury companies. Growth, liquidity, new entrants, and investment-worthy news.</p>
            </div>
            <div className="approach-item">
              <div className="step-number">03</div>
              <h4>Sentiment &amp; Onchain</h4>
              <p>Using market sentiment and on-chain data to read investor psychology. What current signals mean for where we are heading.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section" data-testid="about-cta">
        <h2>Start reading. It's free.</h2>
        <p>Get the Idea of the Week every Tuesday. No cost, no commitment.</p>
        <SubscribeForm showToast={showToast} className="cta-centered" />
      </section>

      <FullFooter onSubscribe={onSubscribe} />
    </>
  );
};

export default About;
